interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  showTagline?: boolean;
  className?: string;
}

export const Logo = ({ size = 'md', showText = true, showTagline = false, className = '' }: LogoProps) => {
  const sizes = {
    sm: { text: 'text-xl', tagline: 'text-xs' },
    md: { text: 'text-2xl', tagline: 'text-sm' },
    lg: { text: 'text-3xl', tagline: 'text-base' },
    xl: { text: 'text-4xl', tagline: 'text-lg' },
  };

  const { text, tagline } = sizes[size];

  return (
    <div className={`flex flex-col items-start leading-none ${className}`} data-testid="logo">
      {showText && (
        <span
          className={`${text} font-black tracking-wide brand-text-gradient`}
          style={{ letterSpacing: '0.06em' }}
        >
          YOWO
        </span>
      )}
      {showTagline && (
        <span className={`${tagline} italic tracking-wide mt-0.5`}>
          <span className="brand-text-gradient font-black not-italic">YO</span>
          <span className="text-slate-400 dark:text-slate-500">u </span>
          <span className="brand-text-gradient font-black not-italic">WO</span>
          <span className="text-slate-400 dark:text-slate-500">n't.</span>
        </span>
      )}
    </div>
  );
};
